import { mapMutations, mapState, mapGetters } from "vuex";
import FlexRow from "@/components/FlexRow.vue";
import { SellerFilter, MarketplaceFilter, ProductFilter, FilterDivider, FilterItemSelector, PortfolioFilter, AdFormatFilter, CampaignFilter, MatchTypeFilter, TargetingFilter, TargetingTypeFilter, CampaignGroupFilter } from "@/components/new-filters";
import { EVENTS, PPC_EXTRA_FILTERS, HANDLE_ADD_FILTER_MODES, FILTER_KEYS, PPC_FILTER_REFRESH_RELATIONSHIPS, PPC_EXTRA_FILTERS_ORDER } from "@/utils/constants";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import AppDropdown from "@/components/AppDropdown.vue";
import AppIcon from "@/components/AppIcon.vue";
import LayoutIcon from "@/components/icons/LayoutIcon.vue";
import TrendingUpIcon from "@/components/icons/TrendingUpIcon.vue";
import CertificateIcon from "@/components/icons/CertificateIcon.vue";
import EqualsIcon from "@/components/icons/EqualsIcon.vue";
import TargetIcon from "@/components/icons/TargetIcon.vue";
import TargetDartIcon from "@/components/icons/TargetDartIcon.vue";
import LayersIcon from "@/components/icons/LayersIcon.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
import PPCManagementMixin from "@/mixins/PPCManagementMixin.vue";
export default {
  name: "PpcV2Filters",
  components: {
    FlexRow,
    SellerFilter,
    MarketplaceFilter,
    ProductFilter,
    FilterDivider,
    FilterItemSelector,
    WrapWithPopover,
    AppDropdown,
    AppIcon,
    CampaignFilter,
    MatchTypeFilter,
    TargetingFilter,
    LayoutIcon,
    CertificateIcon,
    TrendingUpIcon,
    EqualsIcon,
    TargetIcon,
    PortfolioFilter,
    AdFormatFilter,
    TargetingTypeFilter,
    TargetDartIcon,
    CampaignGroupFilter,
    LayersIcon
  },
  mixins: [InitializeFiltersMixin, PPCManagementMixin],
  props: {
    secondaryFilterInitializers: {
      type: Object
    }
  },
  mounted() {
    window.$bus.on(EVENTS.ADD_PPC_FILTER, this.handleAddFilter);

    // NOTE: For now, we have disabled this section which was originally for removing the `SELLER, MARKETPLACE, PRODUCT` filters
    // when the users chose any secondary filters (Campaigns, Portfolio, Targeting, Match Type, Ad Format)

    // Update: 10th January 2025:
    // We are bring back the `hiding` and `showing` of the `Group By` for Product Table
    // We remove [Seller, Marketplace, Product] when any secondary filters are enabled.
    // And bring them back when all the secondary filters are cleared.

    // Update: 7th March 2025:
    // We are changing the strategy a little bit due to some technical challenges with Vue making the components re-render (which in-turn triggers)
    // the `update:modelValue` event. This event is connected to the `refresh` event of the `ProductTable` so any time the `Group By` elements
    // re-render, the page refresh will be triggered.

    // The new strategy is to store in a different list `disabledGroupBy`. This will track elements and then disable the tabs when necessary

    /* this.$store.watch(
      (_, getters) => getters.ppcV2SecondaryFiltersEnabled(),
      (newValue, oldValue) => {
        //console.log("Watching secondary filters", newValue, oldValue);
        if (!oldValue && newValue) {
          // When it changes from false to true
          this.$nextTick(() => {
            this.enableProductFilter = false;
            this.$store.dispatch(
              "ppcV2SetSecondaryFiltersProductTableGroupByElements"
            );
          });
        }
         if (!newValue && oldValue) {
          // When it changes from true to false
          this.$nextTick(() => {
            this.enableProductFilter = true;
            this.$store.dispatch("ppcV2CleanDisabledGroupBy");
          });
        }
      },
      {
        immediate: true,
      }
    ); */
  },
  data() {
    return {
      enableProductFilter: true,
      moreFilterOptions: [{
        name: PPC_EXTRA_FILTERS.AD_FORMAT,
        icon: "LayoutIcon"
      }, {
        name: PPC_EXTRA_FILTERS.PORTFOLIO,
        icon: "CertificateIcon"
      }, {
        name: PPC_EXTRA_FILTERS.CAMPAIGN_GROUP,
        icon: "LayersIcon"
      }, {
        name: PPC_EXTRA_FILTERS.CAMPAIGN,
        icon: "TrendingUpIcon"
      }, {
        name: PPC_EXTRA_FILTERS.TARGETING_TYPE,
        icon: "TargetDartIcon"
      }, {
        name: PPC_EXTRA_FILTERS.TARGETING,
        icon: "TargetIcon"
      }, {
        name: PPC_EXTRA_FILTERS.MATCH_TYPE,
        icon: "EqualsIcon"
      }]
    };
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.ppc_v2.sellers_filter,
      marketplaces_filter: state => state.ppc_v2.marketplaces_filter,
      products: state => state.ppc_v2.products,
      match_types: state => state.ppc_v2.match_types,
      campaigns: state => state.ppc_v2.campaigns,
      targetings: state => state.ppc_v2.targetings,
      targeting_types: state => state.ppc_v2.targeting_types,
      portfolios: state => state.ppc_v2.portfolios,
      ad_formats: state => state.ppc_v2.ad_formats,
      campaign_groups: state => state.ppc_v2.campaign_groups,
      currencies: state => state.ppc_v2.currencies,
      renderedFilterNames: state => state.ppc_v2.renderedFilterNames,
      filterManager: state => state.ppc_v2.filterManager
    }),
    ...mapGetters(["ppcV2SecondaryFiltersEnabled", "ppcV2UserOnSettingsPage", "ppcV2RenderedFilterKeys", "ppcV2FilterRelationParams"]),
    filterDropdownOptions() {
      return this.moreFilterOptions.filter(({
        name
      }) => !this.renderedFilterNames.has(name));
    },
    onlyMode() {
      return this.ppcV2UserOnSettingsPage() ?? false;
    },
    processedFilters() {
      return PPC_EXTRA_FILTERS_ORDER.filter(name => this.renderedFilterNames.has(name)).map(filter => {
        const componentConfig = this.getFilterComponent(filter);
        return {
          name: componentConfig.name,
          props: componentConfig.props,
          methods: componentConfig.methods
        };
      });
    },
    extraFilters() {
      return {
        [PPC_EXTRA_FILTERS.CAMPAIGN]: {
          name: "CampaignFilter",
          props: {
            campaigns: this.campaigns,
            sellers: this.sellers_filter,
            marketplaces: this.marketplaces_filter
          },
          methods: {
            apply: this.applyCampaigns
          }
        },
        [PPC_EXTRA_FILTERS.MATCH_TYPE]: {
          name: "MatchTypeFilter",
          props: {
            match_types: this.match_types
          },
          methods: {
            apply: this.applyMatchTypes
          }
        },
        [PPC_EXTRA_FILTERS.TARGETING]: {
          name: "TargetingFilter",
          props: {
            targetings: this.targetings,
            sellers: this.sellers_filter,
            marketplaces: this.marketplaces_filter
          },
          methods: {
            apply: this.applyTargetings
          }
        },
        [PPC_EXTRA_FILTERS.TARGETING_TYPE]: {
          name: "TargetingTypeFilter",
          props: {
            targeting_types: this.targeting_types
          },
          methods: {
            apply: this.applyTargetingTypes
          }
        },
        [PPC_EXTRA_FILTERS.AD_FORMAT]: {
          name: "AdFormatFilter",
          props: {
            ad_formats: this.ad_formats
          },
          methods: {
            apply: this.applyAdFormats
          }
        },
        [PPC_EXTRA_FILTERS.PORTFOLIO]: {
          name: "PortfolioFilter",
          props: {
            portfolios: this.portfolios,
            sellers: this.sellers_filter,
            marketplaces: this.marketplaces_filter
          },
          methods: {
            apply: this.applyPortfolios
          }
        },
        [PPC_EXTRA_FILTERS.CAMPAIGN_GROUP]: {
          name: "CampaignGroupFilter",
          props: {
            campaign_groups: this.campaign_groups,
            sellers: this.sellers_filter,
            marketplaces: this.marketplaces_filter
          },
          methods: {
            apply: this.applyCampaignGroups
          }
        }
      };
    },
    getProductFilterState() {
      if (this.ppcV2UserOnSettingsPage()) return false;
      return this.enableProductFilter;
    },
    filtersByKey() {
      return {
        [FILTER_KEYS.PRODUCTS]: this.products,
        [FILTER_KEYS.CAMPAIGNS]: this.campaigns,
        [FILTER_KEYS.PORTFOLIOS]: this.portfolios,
        [FILTER_KEYS.AD_FORMATS]: this.ad_formats,
        [FILTER_KEYS.MATCH_TYPES]: this.match_types,
        [FILTER_KEYS.TARGETINGS]: this.targetings,
        [FILTER_KEYS.TARGETING_TYPES]: this.targeting_types,
        [FILTER_KEYS.CAMPAIGN_GROUPS]: this.campaign_groups,
        [FILTER_KEYS.CURRENCIES]: this.currencies
      };
    }
  },
  methods: {
    ...mapMutations(["ppcMarketplacesFilterSet"]),
    async applySellersForCurrentTab() {
      let applySellersFunction = this.ppcV2UserOnSettingsPage() ? this.applySellersForSettingsTab : this.applySellers;
      await applySellersFunction();
      window.$bus.trigger(EVENTS.REFRESH_PPC_AUTOMATION_STATUS);
    },
    async applyMarketPlacesForCurrentTab() {
      let applyMarketPlacesFunction = this.ppcV2UserOnSettingsPage() ? this.applyMarketPlacesForSettingsTab : this.applyMarketplaces;
      await applyMarketPlacesFunction();
      window.$bus.trigger(EVENTS.REFRESH_PPC_AUTOMATION_STATUS);
    },
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for sellers...  ",
          visible: true,
          delay: 50
        });
        /*
          Refresh the list of filters [active]:
            Again, to avoid a lot of 423 (Too Many Reqs) Errors from the server
            We will run the requests in series.
            * Marketplace Filter
            * Product Filter
            * Any other secondary filters currently displayed.
        */
        // [DEPRECATED] Api will soon be changed to use `Filter` instance instead of the `name`
        // await this.initializeMarketplacesFilters(
        //   { sellers: this.sellers_filter.filterValues },
        //   "ppc_v2",
        //   "marketplaces",
        //   "ppc/v2"
        // );

        // [UPDATED] The initializeProductsFilters, intializeMarketplacesFilters API has been updated to the new version

        // We await the next tick to make sure the marketplace was updated.
        await window.$bus.trigger(EVENTS.REFRESH_PPC_V2_SELLERS_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_PPC_MANAGEMENT);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for marketplace...",
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PPC_V2_MARKETPLACES_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_PPC_MANAGEMENT);
      }
    },
    async applySellersForSettingsTab() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS_MARKETPLACES_FILTER, false);
        await window.$bus.trigger(EVENTS.REFRESH_PPC_WEEKS_RANGE);
        await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS);
      }
    },
    async applyMarketPlacesForSettingsTab() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_PPC_WEEKS_RANGE);
        await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS);
      }
    },
    handleErrorOccured() {
      //this.throwIfError({status:'error'});
    },
    async applySecondaryFilter(filterKey) {
      const filter = this.filtersByKey[filterKey];
      if (!filter?.isModified) return;
      filter.apply();
      await this.refreshRelatedFilters(filterKey);
      window.$bus.trigger(EVENTS.REFRESH_PPC_MANAGEMENT);
    },
    // Re-initializes the displayed filters that depend on the one just applied.
    refreshRelatedFilters(filterKey) {
      const relatedKeys = PPC_FILTER_REFRESH_RELATIONSHIPS[filterKey] ?? [];
      const renderedKeys = this.ppcV2RenderedFilterKeys();
      const keysToRefresh = relatedKeys.filter(key => renderedKeys.includes(key));
      if (keysToRefresh.length === 0) return;
      window.$bus.trigger("showSuccess", {
        message: `⏳Fetching sub filters for ${keysToRefresh.join(", ").replaceAll("_", " ")}...`,
        visible: true,
        delay: 50
      });

      // Their lists are rebuilt from scratch, so drop their selections before
      // reading the relation params for the new queries.
      keysToRefresh.forEach(key => this.filtersByKey[key].clearAndApply());
      return this.filterManager?.refreshSet(keysToRefresh, this.ppcV2FilterRelationParams());
    },
    applyMatchTypes() {
      return this.applySecondaryFilter(FILTER_KEYS.MATCH_TYPES);
    },
    applyCampaigns() {
      return this.applySecondaryFilter(FILTER_KEYS.CAMPAIGNS);
    },
    applyTargetings() {
      return this.applySecondaryFilter(FILTER_KEYS.TARGETINGS);
    },
    applyTargetingTypes() {
      return this.applySecondaryFilter(FILTER_KEYS.TARGETING_TYPES);
    },
    applyPortfolios() {
      return this.applySecondaryFilter(FILTER_KEYS.PORTFOLIOS);
    },
    applyCampaignGroups() {
      return this.applySecondaryFilter(FILTER_KEYS.CAMPAIGN_GROUPS);
    },
    applyAdFormats() {
      return this.applySecondaryFilter(FILTER_KEYS.AD_FORMATS);
    },
    applyProducts() {
      return this.applySecondaryFilter(FILTER_KEYS.PRODUCTS);
    },
    applyCurrencies() {
      return this.applySecondaryFilter(FILTER_KEYS.CURRENCIES);
    },
    handleSellerCleared() {
      window.$bus.trigger(EVENTS.ADD_SELLER_GROUPBY);
    },
    handleMarketplaceCleared() {
      window.$bus.trigger(EVENTS.ADD_MARKETPLACE_GROUPBY);
    },
    handleAddFilter({
      value,
      mode = HANDLE_ADD_FILTER_MODES.POPUP
    }) {
      console.log("value", value);
      console.trace("handleAddFilter called with value:", value); // Added for debugging
      this.renderedFilterNames.add(value);
      this.$nextTick(() => {
        const filtersWrapper = this.$refs.filtersWrapper?.$el;
        if (filtersWrapper) {
          filtersWrapper.scroll({
            behavior: "smooth",
            left: filtersWrapper.scrollWidth
          });
        }
        if (mode === HANDLE_ADD_FILTER_MODES.POPUP) {
          const filterComponent = this.getFilterComponent(value)?.name;
          let el = this.$refs[filterComponent];
          if (Array.isArray(el) && el.length > 0) {
            el = el[0];
          }
          if (el?.openDropdown) {
            el.openDropdown(this.secondaryFilterInitializers[value]);
          }
        }
      });
    },
    getFilterComponent(key) {
      return this.extraFilters[key];
    },
    handleErrorOccured() {
      //console.log("[no account]");
      //this.announceNoAccounts();
    }
  }
};